import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Car, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import PageHero from "@/components/PageHero";

export default function Vehicle() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/qr").then(({ data }) => setItems(data.filter((x) => x.type === "vehicle")));
  }, []);

  return (
    <div className="max-w-6xl">
      <PageHero
        kicker="Vehicle safety"
        title="My vehicles"
        subtitle="Stickers that let anyone reach you without exposing your number."
        image="https://images.unsplash.com/photo-1625690180114-5530b1304127?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80"
        testId="vehicle-hero"
      />
      <div className="flex justify-end mb-6 flex-wrap gap-4">
        <Button asChild className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white rounded-full" data-testid="add-vehicle-btn">
          <Link to="/app/qr"><Plus className="w-4 h-4 mr-2" /> Add vehicle QR</Link>
        </Button>
      </div>

      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-16 text-center">
          <Car className="w-10 h-10 mx-auto text-muted-foreground mb-3" />
          <div className="font-medium mb-1">No vehicle QR yet</div>
          <div className="text-sm text-muted-foreground mb-4">Add one and stick it on your dashboard.</div>
          <Button asChild><Link to="/app/qr">Create vehicle QR</Link></Button>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((v) => (
            <div key={v.id} className="rounded-2xl border border-border/70 bg-card p-5" data-testid={`vehicle-card-${v.id}`}>
              <div className="w-10 h-10 rounded-xl bg-[hsl(var(--primary))]/10 grid place-items-center mb-3">
                <Car className="w-5 h-5 text-[hsl(var(--primary))]" />
              </div>
              <div className="font-display font-bold text-lg tracking-tight">{v.display_name}</div>
              <div className="text-sm text-muted-foreground mb-3">{v.vehicle_model || "—"}</div>
              <div className="text-xs text-muted-foreground border-t border-border/50 pt-3">
                {v.vehicle_number || "No plate"} · {v.scan_count} scans
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
